import { LoadState } from "../../constants/enums";

export interface IDocumentTrainingItem {
  [key: string]: any;
}

export interface IDocumentTrainingListItem {
  discount_document_id: number | null;
  discount_document_code: string;
  company_name: string;
  document_type: string;
  policy_type: string;
  file_path: string;
  version: string;
  effective_from: string;
  is_current: number;
  status: string;
  total_chunks: number | null;
  total_discount_items: number | null;
  error_message: string | null;
  created_by_id: string | null;
  modified_by_id: string | null;
  create_ts: string | null;
  insert_ts: string | null;
}

export interface IDocumentTrainingDetail extends IDocumentTrainingListItem {
  items: IDocumentTrainingItem[];
}

export interface IDocumentTrainingListResponse {
  message: string;
  totalRecords: number;
  currentRecords: number;
  data: IDocumentTrainingListItem[];
}

export interface IDocumentTrainingState {
  list: IDocumentTrainingListItem[];
  totalRecords: number;
  listLoading: LoadState;
  detail: IDocumentTrainingDetail;
  detailLoading: LoadState;
  ingestionLoading: LoadState;
  ingestionStatus: string | null;
  error: string | null;
}

export const initialDocumentTrainingListItem: IDocumentTrainingListItem = {
  discount_document_id: null,
  discount_document_code: "",
  company_name: "",
  document_type: "",
  policy_type: "",
  file_path: "",
  version: "",
  effective_from: "",
  is_current: 0,
  status: "",
  total_chunks: null,
  total_discount_items: null,
  error_message: null,
  created_by_id: null,
  modified_by_id: null,
  create_ts: null,
  insert_ts: null,
};

export const initialDocumentTrainingDetail: IDocumentTrainingDetail = {
  ...initialDocumentTrainingListItem,
  items: [],
};

export const initialDocumentTrainingState: IDocumentTrainingState = {
  list: [],
  totalRecords: 0,
  listLoading: LoadState.NotLoaded,
  detail: initialDocumentTrainingDetail,
  detailLoading: LoadState.NotLoaded,
  ingestionLoading: LoadState.NotLoaded,
  ingestionStatus: null,
  error: null,
};
